module.exports = __webpack_public_path__ + "static/full-astro-a1df50c8e0425166b42d5b6f5564bffd.jpg";